import axios from "axios"
export function approveApplication(userId, token, fname, email) {
    return axios.get(process.env.REACT_APP_API_URL + `/approveApplication?userId=${userId}&fname=${fname}&email=${email}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}